export default "__VITE_ASSET__f12a7001__"